import axios from 'axios'
import router from '../router/index'
import {isString} from "./stringHelper";
import store from '../store/index'


function Delete(url, onSuccess, onError) {

    axios.delete(url, {headers: {Authorization: 'Bearer ' + this.$store.getters.apiToken}})
        .then(onSuccess ? onSuccess :
            () => {
                window.toastr.success('Registro eliminado correctamente.')
                this.$emit('deleted')
            }).catch(onError ? onError :
        (err) => {
            store.commit('setLoading',false)
            this.errors = processCatch(err)
        })
}

function Post(url, data, onSuccess, onError) {
    axios.post(url, data, {headers: {Authorization: 'bearer ' + this.$store.getters.apiToken}})
        .then(onSuccess ? onSuccess :
            () => {
                if (store.getters?.loading)
                    store.commit('setLoading',false)
                window.toastr.success('Operación realizada correctamente')
            })
        .catch(onError ? onError :
            (err) => {
                store.commit('setLoading',false)
                this.errors = processCatch(err)
            })
}

function Put(url, data, onSuccess, onError) {
    axios.put(url, data, {headers: {Authorization: 'bearer ' + this.$store.getters.apiToken}})
        .then(onSuccess ? onSuccess :
            () => {
                window.toastr.success('Operación realizada correctamente')
            })
        .catch(onError ? onError :
            (err) => {
                store.commit('setLoading',false)
                this.errors = processCatch(err);
            })
}

function Get(url, onSuccess, onError) {
    axios.get(url, {headers: {Authorization: 'Bearer ' + this.$store.getters.apiToken}})
        .then(onSuccess)
        .catch(onError ? onError :
            (err) => {
                store.commit('setLoading',false)
                this.errors = processCatch(err);
            })
}

function GetSimple(url) {
    return axios.get(url, {headers: {Authorization: 'Bearer ' + this.$store.getters.apiToken}});
}

function processCatch(err) {
    let res = {}
    if (err.response) {
        if (err.response.status === 401 || err.response.status === 403){
            window.toastr.error('Acceso no autorizado')
            router.push('/login')
        }
        else if (err.response.data && !isString(err.response.data) && err.response.data.errors)
            res = err.response.data.errors
        else if (err.response.data && !isString(err.response.data))
            res = err.response.data
        else if (isString(err.response.data) && err.response.data.length > 0)
            window.toastr.error(err.response.data)
    }
    return res
}

export {Delete, Post, Get, Put, GetSimple}